export default function slugToSentenceCase(slug: string) {
  return slug
    .toLowerCase()
    .split('-')
    .filter(Boolean)
    .map(part => part[0].toUpperCase() + part.slice(1))
    .join(' ')
}